/**
 * @generated SignedSource<<f94a717fb2390d30ac2882e255bc33e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeactivateBambooHRInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeactivateBambooHRMutation$variables = {
  input: DeactivateBambooHRInput;
};
export type DeactivateBambooHRMutation$data = {
  readonly deactivateBambooHR: {
    readonly company: {
      readonly bambooHREnabled: boolean | null;
    } | null;
  } | null;
};
export type DeactivateBambooHRMutation = {
  variables: DeactivateBambooHRMutation$variables;
  response: DeactivateBambooHRMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bambooHREnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeactivateBambooHRMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeactivateBambooHRPayload",
        "kind": "LinkedField",
        "name": "deactivateBambooHR",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeactivateBambooHRMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeactivateBambooHRPayload",
        "kind": "LinkedField",
        "name": "deactivateBambooHR",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dc46995adec0bb5f82ba2d3e89125646",
    "id": null,
    "metadata": {},
    "name": "DeactivateBambooHRMutation",
    "operationKind": "mutation",
    "text": "mutation DeactivateBambooHRMutation(\n  $input: DeactivateBambooHRInput!\n) {\n  deactivateBambooHR(input: $input) {\n    company {\n      bambooHREnabled\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "74d4c816bdea935a4057c6baea2c2d62";

export default node;
